import { useQuery, useQueryClient } from "@tanstack/react-query";
import { baseUrl } from "../../../../Environments/environment";
import { useAuth } from "../../../../Contexts/AuthContext/AuthContext";
import { useSocket } from "../../../../Contexts/SocketContext/SocketContext";
import { useProperty } from "../../../../Contexts/PropertyContext/PropertyContext";
import { useEffect, useState } from "react";
import { BroadcastScreen } from "../BroadcastScreen/BroadcastScreen";
import CreateBroadcast from "../CreateBroadCast/CreateBroadCast";
import { apiClient } from "../../../../api";

// Function to fetch broadcast list
const fetchBroadcastList = async (baseUrl, selectedPropertyId, accessToken) => {
	const response = await apiClient.get(
		`${baseUrl}/broadcast/${selectedPropertyId}`
	);
	if (response.ok) {
		const newToken = response.headers.get("Authorization");
		if (newToken) {
			localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
		}
	}
	return response.data.result;
};

const useReactQuerySubscription = (socket, baseUrl, selectedPropertyId) => {
	const queryClient = useQueryClient();

	useEffect(() => {
		// Listen for new broadcast events
		socket.on("broadcast:newBroadcast", () => {
			queryClient.invalidateQueries({
				queryKey: ["broadcastList", selectedPropertyId],
			});
		});

		return () => {
			socket.off("broadcast:newBroadcast");
		};
	}, [socket, queryClient, baseUrl, selectedPropertyId]);
};

export const BroadCastList = ({ broadcastDate, guests }) => {
	const { accessToken } = useAuth();
	const { selectedPropertyId } = useProperty();
	const { socket } = useSocket();
	const [selectedBroadcast, setSelectedBroadcast] = useState(null);
	const [isCreateBroadcastOpen, setIsCreateBroadcastOpen] = useState(false);
	//  console.log(guests);
	useReactQuerySubscription(socket, baseUrl, selectedPropertyId);

	const {
		data: broadcasts = {},
		isLoading,
		error,
	} = useQuery({
		queryKey: ["broadcastList", selectedPropertyId],
		queryFn: () => fetchBroadcastList(baseUrl, selectedPropertyId, accessToken),
		staleTime: 60000,
		cacheTime: 600000,
	});

	const groupBroadcastsByDate = (broadcasts) => {
		if (!broadcasts) {
			return {};
		}
		return broadcasts.reduce((acc, broadcast) => {
			const date = new Date(broadcast.updatedAt).toDateString();
			if (!acc[date]) {
				acc[date] = [];
			}
			acc[date].push(broadcast);
			return acc;
		}, {});
	};

	const sortDates = (dates) => {
		const today = new Date().toDateString();
		const yesterday = new Date(
			new Date().setDate(new Date().getDate() - 1)
		).toDateString();

		return dates.sort((a, b) => {
			if (a === today) return -1;
			if (b === today) return 1;
			if (a === yesterday) return -1;
			if (b === yesterday) return 1;
			return new Date(b) - new Date(a);
		});
	};

	const getDateLabel = (date) => {
		const today = new Date().toDateString();
		const yesterday = new Date(
			new Date().setDate(new Date().getDate() - 1)
		).toDateString();

		if (date === today) return "Today";
		if (date === yesterday) return "Yesterday";
		return date;
	};

	const openBroadcastScreen = (broadcast) => {
		setSelectedBroadcast(broadcast);
	};

	const handleOpenCreateBroadcast = () => {
		setIsCreateBroadcastOpen(true);
	};

	const handleCloseCreateBroadcast = () => {
		setIsCreateBroadcastOpen(false);
	};

	return (
		<div className="p-">
			<div
				className="text-indigo-600 text-sm text-right hover:text-indio-500 cursor-pointer px-1"
				onClick={handleOpenCreateBroadcast}
			>
				+ New Broadcast
			</div>

			{/* brodcast list */}
			<div className="overflow-y-auto h-[57vh]">
				{broadcasts?.broadcasts ? (
					sortDates(
						Object.keys(groupBroadcastsByDate(broadcasts.broadcasts))
					).map((date) => (
						<div
							key={date}
							className="mt-"
						>
							<div className="text-sm px-4 py-1 text-gray-500 bg-gray-100">
								{getDateLabel(date)}
							</div>
							<hr className="border-gray-200" />
							<ul className="divide-y divide-gray-200 ">
								{groupBroadcastsByDate(broadcasts.broadcasts)[date].map(
									(broadcast) => (
										<li
											key={broadcast._id}
											className="flex items-center justify-between p-2 px-4 space-x-4 hover:bg-gray-50 cursor-pointer"
											// onClick={() => openBroadcastScreen(broadcast)}
											onClick={() => openBroadcastScreen(broadcast)}
										>
											<div className="flex items-center space-x-4 ">
												<div className="flex-shrink-0">
													<div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-indigo-500 text-white">
														{broadcast.guestIds.length}
													</div>
												</div>
												<div className="flex-1 min-w-0">
													<div className="text-sm font-medium text-gray-900 flex gap-2">
														{`${broadcast.guestIds.length} guests`}
													</div>
												</div>
											</div>
											<div className="text-right text-sm text-gray-500">
												{broadcast?.createdAt &&
													new Date(broadcast.createdAt).toLocaleTimeString([], {
														hour: "2-digit",
														minute: "2-digit",
													})}
											</div>
										</li>
									)
								)}
							</ul>
						</div>
					))
				) : (
					<p>Loading</p>
				)}
			</div>

			{/* Render CreateBroadcast component */}
			{isCreateBroadcastOpen && (
				<CreateBroadcast
					guests={guests}
					onClose={handleCloseCreateBroadcast}
				/>
			)}

			{selectedBroadcast && (
				<BroadcastScreen
					broadcast={selectedBroadcast}
					onClose={() => setSelectedBroadcast(null)}
				/>
			)}
		</div>
	);
};
